import { UsageExampleLanguageDisplaySettings } from "./ui-store.types";
import { ReactComponent as ShellIcon } from '../assets/icons/terminal-solid.svg';
import { ReactComponent as JavascriptIcon } from '../assets/icons/js-square-brands.svg';
import { ReactComponent as PythonIcon } from '../assets/icons/python-brands.svg';

export enum UsageExampleLanguages {
    Shell = 'Shell',
    Javascript = 'Javascript',
    Python = 'Python',
  }

export const UsageExampleLanguagesDisplaySettings: {[lang: string]: UsageExampleLanguageDisplaySettings} = {
    'Shell': {
        title: 'Shell',
        icon: ShellIcon,
    },
    'Javascript': {
        title: 'Javascript',
        icon: JavascriptIcon,
    },
    'Python': {
        title: 'Python',
        icon: PythonIcon,
    }
}

  